import React from 'react';
import { StyleSheet, Text, TextStyle, View } from 'react-native';
import Svg, { Circle, G, Use } from 'react-native-svg';
import theme from '../../theme';

const phi = 1.61803398875;
const threeQuarterAdjustment = 0.75;
const smallCircleCenter = (
  radiusBigCirlce,
  xBigCircle,
  yBigCircle,
  valuePercent,
) => {
  return {
    smallCircleX:
      xBigCircle +
      Math.round(
        radiusBigCirlce *
          Math.cos(
            phi +
              2 * ((valuePercent / 100) * threeQuarterAdjustment) * Math.PI +
              1.5 * Math.PI,
          ),
      ),
    samllCircleY:
      yBigCircle +
      Math.round(
        radiusBigCirlce *
          Math.sin(
            phi +
              2 * ((valuePercent / 100) * threeQuarterAdjustment) * Math.PI +
              1.5 * Math.PI,
          ),
      ),
  };
};
interface ITrackingGaugeData {
  color: string;
  percent: number;
  rotation: number;
}

interface IProps {
  data: ITrackingGaugeData[];
  valAndUnit: string;
  valuePercent: number;
  strokeWidth: number;
  radius: number;
  smallCircleRadius: number;
  centerTextStyle: TextStyle;
  bottomTextStyle: TextStyle;
  bottomText: string;
}

export const TrackingGauge = ({
  data,
  valuePercent,
  valAndUnit,
  strokeWidth,
  radius,
  centerTextStyle,
  bottomTextStyle,
  smallCircleRadius,
  bottomText,
}: IProps) => {
  const circumference = Math.PI * 2 * radius;
  const size = radius * 2 + strokeWidth + 9;
  const { smallCircleX, samllCircleY } = smallCircleCenter(
    radius,
    size / 2,
    size / 2,
    valuePercent,
  );

  return (
    <View style={{ width: size, height: size }}>
      <Svg width={size} height={size}>
        <G transform={`rotate(${135},${size / 2},${size / 2})`}>
          {data.map((item: ITrackingGaugeData, index) => {
            return (
              <Circle
                id={index === data.length - 2 ? 'zIndex1' : ''}
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke={item.color}
                strokeWidth={strokeWidth}
                fill='none'
                strokeLinecap={
                  !index || index === data.length - 2 ? 'round' : 'butt'
                }
                transform={`rotate(${
                  ((360 * item.rotation) / 100) * threeQuarterAdjustment
                },${size / 2},${size / 2})`}
                strokeDasharray={[
                  (circumference * threeQuarterAdjustment * item.percent) / 100,
                  circumference,
                ]}
              />
            );
          })}
          <Circle
            id='zIndex2'
            cx={smallCircleX}
            cy={samllCircleY}
            r={smallCircleRadius}
            stroke={theme.BLACK}
            fill={theme.WHITE}
          />
        </G>
      </Svg>
      <View
        style={[
          StyleSheet.absoluteFill,
          { justifyContent: 'center', alignItems: 'center' },
        ]}
      >
        <Text style={centerTextStyle}>{valAndUnit}</Text>
      </View>
      <Text style={bottomTextStyle}>{bottomText}</Text>
    </View>
  );
};
